/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Canvas_Sign_In_Required_TitleInputs */



/**
* | output |
* | --- |
* | "Sign in to continue" |
*
* @param {Canvas_Sign_In_Required_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const canvas_sign_in_required_title = /** @type {((inputs?: Canvas_Sign_In_Required_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Canvas_Sign_In_Required_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Zum Fortfahren anmelden")
	return /** @type {LocalizedString} */ ("Sign in to continue")
});